var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackExcellent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#6ebf43",
    cx: 50,
    cy: 50,
    r: 41.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4c852c",
    d: "M50,93.47c-23.97,0-43.47-19.5-43.47-43.47S26.03,6.53,50,6.53s43.47,19.5,43.47,43.47-19.5,43.47-43.47,43.47ZM50,9.53c-22.32,0-40.47,18.15-40.47,40.47s18.15,40.47,40.47,40.47,40.47-18.16,40.47-40.47S72.32,9.53,50,9.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#406e23",
    d: "M42.38,49.27c-.25.19-.59.22-.87.06-6.62-3.65-13.77-1.79-15.32-1.49-.05,0-.1.02-.15.02-.3,0-.58-.17-.71-.45-.2-.41.05-.79.41-1.07,1.14-.92,8.55-7.13,16.75,1.74.31.35.27.9-.11,1.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#406e23",
    d: "M57.62,49.27c.25.19.59.22.87.06,6.62-3.65,13.77-1.79,15.32-1.49.05,0,.1.02.15.02.3,0,.58-.17.71-.45.2-.41-.05-.79-.41-1.07-1.14-.92-8.55-7.13-16.75,1.74-.31.35-.27.9.11,1.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#406e23",
    d: "M35.13,63.94s2.41,10.78,14.87,10.78,14.87-10.78,14.87-10.78h-29.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackExcellent);
export default __webpack_public_path__ + "static/media/feedback-excellent.a667ed6ca555cec9b9f22b379fffb15f.svg";
export { ForwardRef as ReactComponent };